import moment from 'moment';

export default function parseDate(date) {
  return date ? moment(date).format('YYYY-MM-DD HH:mm:ss') : '';
}
